import React, { useEffect, useState, useRef, useCallback } from "react";
import Loading from 'components/Loading/Loading';
import { __callbacks } from "Utils/Callbacks/Callback";
import { __chats } from 'Utils/Chats/Chats';
import { AppState } from 'Utils/Enums';
import { IChatMessageFragment } from 'Utils/Interfaces';
import { __map } from 'Utils/Map/Map';
import Conversation from '../Conversation/Conversation';
import styles from "./Recent.module.scss";
import { __utils } from 'Utils/Utils';
import { __pusher } from "../../../../Utils/Pusher/pusher";

export default function Recent(props: any) {
    const [conversations, setConversations] = useState<IChatMessageFragment[]>([]);
    const [totalConversations, setTotalConversations] = useState(0);
    const [classLoading, setClassLoading] = useState(styles.loading);
    const container = useRef<HTMLDivElement | null>(null);

    const initFromLocalStorage = useCallback(() => {
        __chats.onInitFromLocalStorage((chats: any) => {
            if (chats) {
                Object.keys(chats).forEach(chatId => {
                    const chatMessages = chats[chatId];
                    if (chatMessages) {
                        const lastMessage = chatMessages[chatMessages.length - 1];
                        if (lastMessage && lastMessage.fragments.length > 0) {
                            const lastFragment = lastMessage.fragments[lastMessage.fragments.length - 1];
                            lastFragment["operator"] = __map.mapChatMessageType(lastFragment);
                            lastFragment["message"] = __map.mapChatMessageFragment(lastFragment);
                            setConversations(arr => {
                                const updatedArr = [...arr, lastFragment];
                                return updatedArr;
                            });
                        }
                        // Initialize Pusher channel for each chat
                        //__pusher.createChannel(chatId);
                    }
                });
                // Update total conversations count
                setTotalConversations(Object.keys(chats).length);
            }
        });
    }, []);

    const initListeners = useCallback(() => {

        __callbacks.onChatMessage((data: any) => {
            const lastFragment = data.lastFragment;
            if (lastFragment) {
                lastFragment["operator"] = __map.mapChatMessageType(lastFragment);
                lastFragment["message"] = __map.mapChatMessageFragment(lastFragment);
                setConversations(arr => {
                    const updatedArr = [...arr, lastFragment];
                    return updatedArr;
                });
            }
        });
    }, []);

    useEffect(() => {
        initListeners();
        setTimeout(() => {
            initFromLocalStorage();
            setClassLoading(styles["hide-hard"]);
        }, 1000);
    }, [initFromLocalStorage, initListeners]);

    const onSeeAllConversationsClick = () => {
        __callbacks.seeAllConversationsClick.trigger({ data: "you clicked on all conv" });
    };

    useEffect(() => {
        __chats.onTotalConversations((data: any) => {
            setTotalConversations(data.totalConversations);
        });
    }, [conversations]);

    const sortDesc = ((a: any, b: any) => b.time - a.time);
    const removeDuplicates = ((value: IChatMessageFragment, index: number, self: IChatMessageFragment[]) =>
        index === self.findIndex((t) => (
            t.chatId === value.chatId
        )));

    const removeEmpty = (value: any) => {
        if (typeof value.message === 'string' && __utils.HTMLstrip(value.message).length > 1) {
            return true;
        } else {
            return false;
        }
    };

    const getFiltered = (arr: IChatMessageFragment[]) => {
        const filtered = arr.sort(sortDesc).filter(removeDuplicates).filter(removeEmpty);

        //console.log("Filtered conversations:", JSON.stringify(filtered));

        return filtered;
    };

    const topThree = (arr: IChatMessageFragment[]) => {
        return arr.slice(0, 3);
    };

    useEffect(() => {
        const element = container.current;
        if (element) {
            element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
        }
    }, [container, conversations]);

    return (
        <div ref={container} className={styles.container}>
            <div className={classLoading}><Loading {...{ color1: "black", color2: "#4a4a4a" }}></Loading></div>
            {props.topThree ?
                topThree(getFiltered(conversations)).map((fragment, index) => {
                    return (
                        <div key={index} id={fragment.chatId} className={`${styles["container-continue-conversation"]} config-container-continue-conversation`}>
                            <Conversation chatMessageFragment={fragment} backState={AppState.home}></Conversation>
                        </div>
                    );
                }) :
                getFiltered(conversations).map((fragment, index) => {
                    return (
                        <div key={index} className={`${styles["container-continue-conversation"]} config-container-continue-conversation`}>
                            <Conversation chatMessageFragment={fragment} backState={AppState.allConversations}></Conversation>
                        </div>
                    );
                })
            }
            {props.topThree && getFiltered(conversations).length > 3 &&
                <div className={styles.more} onClick={onSeeAllConversationsClick}>
                    <span>See all your conversations</span>&nbsp;
                    <span className={styles["total-chats-no"]}>{totalConversations}</span>
                </div>
            }
        </div>
    );
}
